/* eslint-disable quotes */
export default {
  common: {
    loading: "Loading",
  },
  country: {
    heading: "Get your card",
    info: "Find out where to get the ISIC card by selecting your place of residence or study.",
  },
  onlineIssuing: {
    heading: "Online order",
    info: "You can order your card online by clicking on the button below.",
    button: "Order card",
  },
  pos: {
    heading: "Local offices",
    info: "You can get your card at one of the local ISIC issuing outlets."
      + "We suggest you contact them to double check opening houts and card availability.",
    item: {
      cardAvability: "Available cards",
      tooltip: {
        email: "Email",
        phone: "Phone",
        website: "Website",
      },
    },
  },
  notAvailable: {
    info: "<p>We are sorry, the ISIC card is currently not available in your country."
      + "You can check the availability in one of the neighbouring countries.</p>"
      + "<p><b>Do you know organization that might be interested to issue ISIC cards?</b></p>"
      + "<p>Please <a href=\"https://www.isic.org/contact/\">let us know</a>"
      + " and we will get in touch with them to bring ISIC card to your country.</p>",
  },
};
